import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setScale } from "../features/ui/uiSlice";

import { checkStudent, fetchStudent } from "../features/student/studentSlice";

import { BASE_WIDTH } from "../constants/baseInfo";

import TopNavBar from "../components/TopNavBar";
import TopBar from "../components/TopBar";
import AssignmentTable from "../features/assignment/components/AssignmentTable";
import FinishedAssignmentTable from "../features/assignment/components/FinishedAssignmentTable";
import PaperAssignmentTable from "../features/paper-assignment/components/PaperAssignmentTable";

const HomePage = () => {
  const tabList = [
    {
      name: "paper-assignment",
      text: "알림장 및 과제",
    },
    {
      name: "unfinished",
      text: "미완료 과제",
    },
    {
      name: "finished",
      text: "완료 과제 목록",
    },
  ];

  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.student);
  const { mode } = useSelector((state) => state.ui);
  const [topTab, setTopTab] = useState("paper-assignment");
  const [inWebView, setInWebView] = useState(false);

  const isMobile = mode === "mobile";

  const isWebView = () => {
    const userAgent = window.navigator.userAgent || "";
    return /FBAN|FBAV|Instagram|Line|KAKAOTALK|wv/i.test(userAgent);
  };

  const openExternalBrowser = () => {
    const url = window.location.href;
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPhone|iPad|iPod/.test(userAgent)) {
      // iOS: 카카오톡 외부 브라우저로 열기
      window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
        url
      )}`;
    } else {
      // Android: 기본 브라우저에서 열기
      window.location.href = `intent://${url.replace(
        /^https?:\/\//,
        ""
      )}#Intent;scheme=https;package=com.android.chrome;end;`;
    }
  };

  useEffect(() => {
    const currentWidth = window.innerWidth; // 현재 너비
    const scaleX = currentWidth / BASE_WIDTH; // X축 비율
    dispatch(setScale(scaleX));

    const queryParams = new URLSearchParams(window.location.search);
    const session = queryParams.get("session");

    if (session) {
      try {
        const decoded = atob(session);
        const [id, randomCode] = decoded.split(":");
        dispatch(checkStudent({ studentId: id, randomCode: randomCode }));
        setInWebView(isWebView());
        if (isWebView()) {
          openExternalBrowser();
        }
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      const queryParams = new URLSearchParams(window.location.search);
      const session = queryParams.get("session");

      if (session) {
        try {
          const decoded = atob(session);
          const [id, randomCode] = decoded.split(":");
          dispatch(fetchStudent({ studentId: id, randomCode: randomCode }));
        } catch (error) {
          alert("잘못된 URL입니다.");
        }
      } else {
        alert("잘못된 URL입니다.");
      }
    }
  }, [isAuthenticated, dispatch]);

  return (
    <div
      style={{
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#F6F8FA",
        minHeight: "100vh",
      }}
    >
      {inWebView && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <button
            style={{
              width: "50vw",
              height: "20vh",
              fontSize: "2rem",
            }}
            onClick={openExternalBrowser}
          >
            기본 브라우저에서 열기
          </button>
        </div>
      )}
      {!inWebView && isAuthenticated ? (
        <div>
          <TopBar isMobile={isMobile} />
          <TopNavBar
            topTab={topTab}
            setTopTab={setTopTab}
            tabList={tabList}
            isMobile={isMobile}
          />
          {topTab === "unfinished" && <AssignmentTable />}
          {topTab === "finished" && <FinishedAssignmentTable />}
          {topTab === "paper-assignment" && <PaperAssignmentTable />}
        </div>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default HomePage;
